"use client";

import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import anOldHope from "react-syntax-highlighter/dist/esm/styles/hljs/an-old-hope";
import xml from "react-syntax-highlighter/dist/esm/languages/hljs/xml";
import javascript from "react-syntax-highlighter/dist/esm/languages/hljs/javascript";
import typescript from "react-syntax-highlighter/dist/esm/languages/hljs/typescript";
import css from "react-syntax-highlighter/dist/esm/languages/hljs/css";
import scss from "react-syntax-highlighter/dist/esm/languages/hljs/scss";
import php from "react-syntax-highlighter/dist/esm/languages/hljs/php";
import bash from "react-syntax-highlighter/dist/esm/languages/hljs/bash";
import json from "react-syntax-highlighter/dist/esm/languages/hljs/json";
import python from "react-syntax-highlighter/dist/esm/languages/hljs/python";
// import docco from "./docco";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useState, Fragment, useEffect } from "react";
import { getIcon } from "@litonarefin/utils/icons";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";

// Register only the languages this site uses (Light build ships none by default).
SyntaxHighlighter.registerLanguage("html", xml);
SyntaxHighlighter.registerLanguage("xml", xml);
SyntaxHighlighter.registerLanguage("javascript", javascript);
SyntaxHighlighter.registerLanguage("js", javascript);
SyntaxHighlighter.registerLanguage("typescript", typescript);
SyntaxHighlighter.registerLanguage("ts", typescript);
SyntaxHighlighter.registerLanguage("css", css);
SyntaxHighlighter.registerLanguage("scss", scss);
SyntaxHighlighter.registerLanguage("php", php);
SyntaxHighlighter.registerLanguage("bash", bash);
SyntaxHighlighter.registerLanguage("shell", bash);
SyntaxHighlighter.registerLanguage("json", json);
SyntaxHighlighter.registerLanguage("python", python);

export const Html = ({ attributes, originalContent }) => {
  const [copiedText, setCopiedText] = useState({ copied: false });

  useEffect(() => {
    let interval;
    if (copiedText?.copied === true) {
      interval = setInterval(() => {
        setCopiedText({ copied: false });
      }, 6000);
    }
    return () => clearInterval(interval);
  }, [copiedText]);

  return (
    <div {...(attributes?.anchor && { id: attributes?.anchor })} className="jlt-relative">
      <SyntaxHighlighter
        language={attributes?.lang || "html"}
        style={anOldHope}
        wrapLongLines={attributes?.wrapLongLines || true}
        showLineNumbers={attributes?.showLines || true}
      >
        {originalContent}
      </SyntaxHighlighter>

      <CopyToClipboard text={`${originalContent}`} onCopy={() => setCopiedText({ copied: true })}>
        <button
          className={`jlt-absolute jlt-top-1 jlt-right-[6px] jlt-border jlt-border-[#c4c4c4] jlt-py-2 jlt-px-4 jlt-rounded-[4px] jlt-text-xs jlt-flex jlt-items-center jlt-gap-2`}
        >
          {copiedText?.copied ? (
            <Fragment>{getStyledIcon(getIcon("check"), "#c4c4c4", "fill")}</Fragment>
          ) : (
            <Fragment>{getStyledIcon(getIcon("copy"), "#c4c4c4", "stroke")}</Fragment>
          )}
        </button>
      </CopyToClipboard>
    </div>
  );
};

export default Html;
